import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { BrandLogo } from "@/components/brand/BrandLogo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut } from "lucide-react";

export function AppShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => { await logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border/70 sticky top-0 z-30" style={{ background: "rgba(255,252,247,0.92)", backdropFilter: "blur(10px)" }}>
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
          <Link to={user?.role === "admin" ? "/admin" : "/dashboard"} className="block" data-testid="header-brand-link">
            <BrandLogo size={40} />
          </Link>
          {user && user.role && (
            <div className="flex items-center gap-4">
              <div className="hidden md:flex flex-col items-end leading-tight">
                <span className="text-sm font-bold" style={{ color: "#171717" }} data-testid="header-user-name">{user.name}</span>
                <span className="uppercase-label" style={{ fontSize: "0.6rem", color: "#EC008C" }} data-testid="header-user-role">
                  {user.role === "admin" ? "Admin · Tom" : "Referrer"}
                </span>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={onLogout}
                className="rounded-full text-sm gap-1.5 font-bold"
                data-testid="header-logout-button"
              >
                <LogOut size={14} /> Sign out
              </Button>
            </div>
          )}
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 md:px-10 py-8 md:py-12">{children}</main>
      <footer className="border-t border-border/60 mt-16">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 text-xs flex flex-col md:flex-row md:justify-between gap-2" style={{ color: "#7A6D5F" }}>
          <span>© {new Date().getFullYear()} Avocado Property · <a href="https://avocadopropertyagents.co.uk/agent-profile/tom-gilbert" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-foreground" data-testid="footer-tom-link">Tom Gilbert</a></span>
          <span className="uppercase-label" style={{ fontSize: "0.6rem" }}>5% Referral Community · No suits · No leaflets</span>
        </div>
      </footer>
    </div>
  );
}
